import { NextSeo } from "next-seo";

export default function Projects() {
  return (
    <>
      <NextSeo
        title="Projects"
        description={
          "Under Construction: The future home of some of the projects I've worked on."
        }
      />
      <section
        id="projects"
        className="container flex flex-col items-center content-center justify-center"
      >
        <h1
          id="fancy-text"
          className="text-xl font-extrabold tracking-wide md:text-4xl lg:text-6xl dark:text-gray-50"
        >
          <span role="img" aria-label="Construction Sign">
            🚧
          </span>{" "}
          Under Construction{" "}
          <span role="img" aria-label="Construction Sign">
            🚧
          </span>
        </h1>
        <p className="text-lg md:text-2xl lg:text-3xl dark:text-gray-100">
          Please come back soon!
        </p>
      </section>
    </>
  );
}
